import { useState, useEffect, useRef } from "react";
import { classNames } from "../../helpers/classNames";

export default function CheckboxDropdown({
  dropDownData = [],
  mainClasses,
  labelClasses,
  onChange = () => {},
  label = "",
  selected = [],
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedValues = selected.map((item) => item.value);

  const handleSelect = (item) => {
    const isSelected = selectedValues.includes(item.value);
    let updated;

    if (isSelected) {
      updated = selected.filter((s) => s.value !== item.value);
    } else {
      updated = [...selected, item];
    }

    onChange(updated); 
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={classNames("relative", mainClasses)} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={classNames(
          `w-full px-4 py-2 rounded-md bg-transparent flex justify-between items-center ${
            isOpen ? "border-2 border-gray-900" : "border border-gray-300"
          }`,
          labelClasses
        )}
      >
        <span>
          {label} ({selectedValues.length})
        </span>
        <svg
          className={`w-5 h-5 transform transition-transform ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute left-0 mt-2 w-full bg-white rounded-lg shadow-xl z-10 border border-gray-200 max-h-60 overflow-y-auto">
          <div className="flex flex-col w-full divide-gray-100">
            {dropDownData?.map((item) => (
              <div
                key={item.value}
                className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer"
              >
                <input
                  type="checkbox"
                  id={`item-${item.value}`}
                  checked={selectedValues.includes(item.value)}
                  onChange={() => handleSelect(item)}
                  className="w-5 h-5 text-black bg-gray-100 border-gray-300 rounded-sm focus:ring-2 focus:ring-black"
                />
                <label
                  htmlFor={`item-${item.value}`}
                  className="ml-3 text-sm font-medium text-gray-800 capitalize"
                >
                  {item.name}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
